import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Avatar,
  
  Menu,
  MenuItem,
  Divider,
  ListItemIcon,
} from "@mui/material";



import { useState } from "react";


import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import SettingsIcon from "@mui/icons-material/Settings";

import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";


import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
 import { monthNames } from "../../component/constent";
import { useEffect } from "react";
import { currentMonth } from "../../services/dashBoardService";

import MenuIcon from "@mui/icons-material/Menu";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { logoutUser } from "../../services/authService";

export default function Header({
  mobileOpen,
  setMobileOpen,
}) {


const navigate = useNavigate();

const { user, logout } = useAuth();

const [anchorEl, setAnchorEl] = useState(null);

const open = Boolean(anchorEl);



const handleMenuOpen = (event) => {
  setAnchorEl(event.currentTarget);
};

const handleMenuClose = () => {
  setAnchorEl(null);
};

const handleLogout = async () => {
    handleMenuClose();

    try {
        await logoutUser();   // Tell server to invalidate session
    } catch (err) {
        console.error(err);
    }

    logout(); // Clear local storage/context
    navigate("/login", { replace: true });
};


const handleProfile = () => {
  handleMenuClose();
  navigate("/profile");
};





const [monthData, setMonthData] = useState(null);
const loadCurrentMonth = async () => {
  try {
    const res = await currentMonth();
    setMonthData(res.data);


  } catch (err) {
    console.error(err);
  }
};



useEffect(() => {
  loadCurrentMonth();
 
  
}, []);


  return (
    <AppBar position="sticky" >

      <Toolbar className="no-print">

        <IconButton
          color="inherit"
          edge="start"
          sx={{ display: { md: "none" } }}
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <MenuIcon />
        </IconButton>
       <Avatar
  src="/fevicon.ico"
  alt="WGR Logo"
  sx={{
    width: 28,
    height: 28,
    mr: 2,
  }}
/>

 <Typography
          variant="h6"
          sx={{
            flexGrow: 1,
            fontWeight: 700,
            color: "#fff",
          }}
        >WGR Data Management System</Typography>
        

        <IconButton color="inherit">
          <NotificationsIcon />
        </IconButton>

       <IconButton
  color="inherit"
  onClick={handleMenuOpen}
>
  <Avatar>
    {user?.fullName?.charAt(0)?.toUpperCase() || "U"}
  </Avatar>
</IconButton>

<Menu
  anchorEl={anchorEl}
  open={open}
  onClose={handleMenuClose}
  anchorOrigin={{
    vertical: "bottom",
    horizontal: "right",
  }}
  transformOrigin={{
    vertical: "top",
    horizontal: "right",
  }}
>
  <Box sx={{ px: 2, py: 1 }}>
    <Typography fontWeight={600}>
      {user?.fullName}
    </Typography>

    {/* <Typography
      variant="body2"
      color="text.secondary"
    >
      {user?.role}
    </Typography> */}
  </Box>

  <Divider />

  <MenuItem onClick={handleProfile}>
    <ListItemIcon>
      <PersonIcon fontSize="small" />
    </ListItemIcon>

   My Profile
  </MenuItem>

 
  <Divider />

  <MenuItem onClick={handleLogout}>
    <ListItemIcon>
      <LogoutIcon
        color="error"
        fontSize="small"
      />
    </ListItemIcon>

    Logout
  </MenuItem>
</Menu>

      </Toolbar>

    </AppBar>
  );
}